import axios from "axios";
import env from "../variables/config";

axios.defaults.baseURL = env.apiUrl;

const config = () => ({
    headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

/** Stage keys mirror LINKEDIN_STAGE_FILTERS in crm-back — one definition, both ends. */
export type LinkedinStage =
    | "notSeeded"
    | "pending"
    | "processing"
    | "waitingCallback"
    | "doneUnscored"
    | "readyAutoApprove"
    | "needsManualReview"
    | "doneNoOptions"
    | "error"
    | "approvedAuto"
    | "approvedManual";

export interface LinkedinFunnel {
    windowDays: number | null;
    inWindow: number;
    stages: Record<LinkedinStage, number>;
    /**
     * Counted DB-wide instead of inside the window — only the stages fed by a job that
     * ignores the window carry one, so it is partial by design. Matches /bo/auto-approve.
     */
    allTime: Partial<Record<LinkedinStage, number>>;
    nafExcluded: number;
    unusableName: number;
    generatedAt: string;
}

export interface LinkedinFunnelPerson {
    _id: string;
    name: string;
    createdAt?: string;
    status: string | null;
    url: string | null;
    optionCount: number;
    topOption: {
        url: string;
        title?: string;
        score: number | null;
        checks: Record<string, boolean> | null;
    } | null;
    error: string | null;
    lastRunAt: string | null;
}

export interface LinkedinFunnelPage {
    stage: LinkedinStage;
    total: number;
    page: number;
    limit: number;
    totalPages: number;
    data: LinkedinFunnelPerson[];
}

export const getLinkedinFunnel = async (): Promise<LinkedinFunnel> => {
    const res = await axios.get("/admin/people/linkedin-funnel", config());
    return res.data;
};

export const getLinkedinFunnelStage = async (
    stage: LinkedinStage,
    page = 1,
    limit = 50,
    /** Must be the scope of the number the user clicked, or the list contradicts the tile. */
    scope: "window" | "all" = "window"
): Promise<LinkedinFunnelPage> => {
    const res = await axios.get(
        `/admin/people/linkedin-funnel/${stage}?page=${page}&limit=${limit}&scope=${scope}`,
        config()
    );
    return res.data;
};
